var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [_c("sm-loader")], 1)
      : _vm.enrollmentV2
      ? _c(
          "div",
          { staticClass: "underlay" },
          [
            _c("sm-dialog", {
              attrs: {
                visible: true,
                title: _vm.$t("PasskeyEnrollmentPage.title"),
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "hide-border-on-top": true,
                "show-close": false,
                "show-cancel": false,
                "show-confirm": false,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function () {
                    return [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("PasskeyEnrollmentPage.subtitle"))
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.errorMessages.length
                        ? _c("sm-help-card", {
                            staticClass: "pt-2",
                            attrs: { type: "warning" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t(
                                              "PasskeyEnrollmentPage.errors.header"
                                            )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "body",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.errorMessages.join(", ")) +
                                          "\n          "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              3474376339
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content__wrapper" },
                        _vm._l(_vm.infoMap, function (info, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "flex content" },
                            [
                              _c(
                                "div",
                                [
                                  _c("sm-icon", {
                                    attrs: {
                                      name: info.icon,
                                      height: "16px",
                                      width: "16px",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c("span", [
                                  _c("strong", [_vm._v(_vm._s(info.title))]),
                                ]),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(info.description))]),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "sm-button",
                        {
                          staticClass: "retry-button",
                          attrs: {
                            type: "primary",
                            loading: _vm.enrolling,
                            "sm-data-test": "create-passkey-button",
                          },
                          on: { click: _vm.handleCreatePasskey },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("PasskeyEnrollmentPage.setupButton")
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "sm-button",
                        {
                          attrs: {
                            type: "text",
                            "sm-data-test": "back-button",
                          },
                          on: { click: _vm.handleBack },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("PasskeyEnrollmentPage.backButton")
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }